import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'mode-github-sync-indicator',
  templateUrl: './github-sync-indicator.component.html',
  styleUrls: ['./github-sync-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GithubSyncIndicatorComponent implements OnChanges {
  @Input() lastSyncedAt?: Date;
  @Input() contentType = '';
  @Input() hasUnsyncedChanges = false;
  @Input() githubSyncMenuName = '';

  neverSyncedLabel = '';
  unsyncedLabel = '';

  public ngOnChanges(changes: SimpleChanges) {
    if (changes['contentType']) {
      this.updateNeverSyncedLabel(changes['contentType'].currentValue);
    }
    if (changes['githubSyncMenuName']) {
      this.updateUnsyncedLabel(changes['githubSyncMenuName'].currentValue);
    }
  }

  updateNeverSyncedLabel(contentType: string) {
    this.neverSyncedLabel = `This ${contentType} has not been synced`;
  }

  updateUnsyncedLabel(githubSyncMenuName: string) {
    this.unsyncedLabel = `There are uncommitted changes. Commit changes to GitHub from the ${githubSyncMenuName} menu.`;
  }
}
